<img [style.width]="sizePx" [style.height]="sizePx" *ngIf="identicon" [src]="identicon" />
<div [style.width]="sizePx" [style.height]="sizePx" *ngIf="!identicon"></div>
